import { connect } from 'react-redux';
import { RankingPageType } from '../../../../../../domain/constants/GlobalNavigation';
import { IRankingState } from '../../../../common/store/ranking/ranking';
import Component, { IRankingProps as IProps } from '../../components/js/ranking/Ranking';
import { IGlobalNavigationState } from '../../store/globalNavigation';
import { IPageDataState } from '../../store/pageData';

interface OwnProps {
  yadsDs?: string;
  typeTag?: string;
}
interface State {
  globalNavigation: IGlobalNavigationState;
  commentRanking?: IRankingState;
  pageData: IPageDataState;
}

const mapStateToProps = (state: State, ownProps?: OwnProps): IProps => {
  if (!state.commentRanking?.list || state.commentRanking.list.length === 0) {
    return { isError: true, ultSec: '', categoryId: '' };
  }
  const currentPageIsAccessRanking =
    state.globalNavigation.currentRanking && state.globalNavigation.currentRanking === RankingPageType.ACCESS;
  const currentPageIsArticleDetail = state.pageData.pageParam.pagetype === 'detail';
  return {
    title: state.commentRanking.title,
    url: state.commentRanking.url,
    list: state.commentRanking.list,
    isError: false,
    ultSec: 'cmtrate',
    yadsDs: ownProps?.yadsDs ?? (currentPageIsArticleDetail || currentPageIsAccessRanking ? undefined : '90113_265661'),
    typeTag: ownProps?.typeTag,
    shannonId: state.pageData.yads.shannonId,
    categoryId: state.pageData.yads.categoryId
  };
};

export default connect(mapStateToProps, {})(Component);
